<template>
  <div class="content">
    <preview-word :wordURL="detail.content"  v-if="detail.type === 'word'"/>
    <preview-pdf :pdfUrl="detail.content"  v-if="detail.type === 'pdf'" />
  </div>
</template>

<script>
import previewWord from './components/preview-word'
import previewPdf from './components/preview-pdf'
export default {
  components: {
    previewWord,
    previewPdf
  },
  computed: {
    parames() {
      return this.$route.query
    }
  },
  data() {
    return {
      detail: {}
    }
  },
  mounted() {
    this.queryDocumentDetail();
  },
  methods: {
    queryDocumentDetail() {
      const { id, searchKey, sequenceNumber } = this.parames;
      this.$api.help
        .queryDocumentDetail({ id, searchKey, sequenceNumber })
        .then((res) => {
          this.detail = res.data;
        });
    },
  }
}
</script>

<style lang="stylus" scoped>
  .content {
    width: 100vw;
    height: 100vh;
    overflow-y:auto;
  }
</style>